// Base Vue library
import Vue, { PluginObject } from 'vue';
import VeeValidate from 'vee-validate';
import router from './routes';
import store from './store/store';
import {MenuItemComponent} from './components/menu-item';
import {MobileMenuItemComponent} from './components/mobile-menu-item';
import 'mdn-polyfills/String.prototype.includes';
import 'mdn-polyfills/String.prototype.startsWith';


// Custom application code below
import {App} from './app';

import '../styles/styles.scss';

Vue.use(VeeValidate as PluginObject<any>, { inject: false });
Vue.component('menu-item', MenuItemComponent);
Vue.component('mobile-menu-item', MobileMenuItemComponent);

// Register global component
//Vue.component('sample', Sample);

new Vue({
  // Root vue element
  el: '#root',
  store,
  // Register root level router
  router: router,
  // Register local components
  components: {
    App
  }
})



// WEBPACK FOOTER //
// src/main.ts